<template>
  <div class="roma-page-content fill-height bg-white">
    <!-- <v-container> -->
      <EvaluationsHeader title="Mis evaluaciones por tomar" />
      <EvaluationsContent :items="8" />
    <!-- </v-container> -->
  </div>
</template>

<script>
import EvaluationsHeader from "@/components/evaluations/EvaluationsHeader";
import EvaluationsContent from "@/components/evaluations/EvaluationsContent";
export default {
  props: {
    sidebarExpanded: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    EvaluationsHeader,
    EvaluationsContent
  }
};
</script>

<style>
  .bg-white{
    background: white !important;
  }
  .pading-sidebar-expanded{
    padding-left: 360px !important;
  }

  .pading-sidebar-minimized{
    padding-left: 100px !important;
  }
</style>
